module.exports = __webpack_public_path__ + "static/media/History.c1c255fe.gif";